"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var checkSvg = require("../../icons/checkThick-16.svg");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var Icon_1 = require("../../icons/Icon");

var constants_1 = require("../../utils/constants");

exports.checkedCheckboxStyle = hs_web_style_guide_1.css({
  width: 16,
  height: 16,
  borderRadius: 2,
  backgroundColor: colors_1.vistaBlue,
  userSelect: 'none',
  cursor: 'pointer',
  fontSize: 0
});
exports.uncheckedCheckboxStyle = hs_web_style_guide_1.css({
  width: 12,
  height: 12,
  borderRadius: 2,
  border: "2px solid " + colors_1.carrarra,
  backgroundColor: colors_1.white,
  cursor: 'pointer',
  userSelect: 'none',
  fontSize: 0
});

var Checkbox =
/** @class */
function (_super) {
  __extends(Checkbox, _super);

  function Checkbox(props) {
    var _this = _super.call(this, props) || this;

    _this.getSelectedValue = function (selected) {
      return selected === undefined ? false : selected;
    };

    _this.handleCheckboxKeyPress = function (event) {
      if (event.keyCode === constants_1.SPACE_KEY) {
        event.stopPropagation();

        _this.toggleSelect();
      }
    };

    _this.handleCheckboxClick = function (event) {
      event.stopPropagation();

      _this.toggleSelect();
    };

    _this.toggleSelect = function () {
      var selected = _this.state.selected;
      var onChange = _this.props.onChange;

      _this.setState({
        selected: !selected
      });

      onChange(!selected);
    };

    _this.state = {
      selected: _this.getSelectedValue(props.selected)
    };
    return _this;
  }

  Checkbox.prototype.componentWillReceiveProps = function (nextProps) {
    var selected = this.props.selected;

    if (nextProps.selected !== selected) {
      this.setState({
        selected: this.getSelectedValue(nextProps.selected)
      });
    }
  };

  Checkbox.prototype.render = function () {
    var _this = this;

    var selected = this.state.selected;
    return React.createElement("div", {
      role: "checkbox",
      "aria-checked": selected,
      tabIndex: 1,
      onKeyUp: function onKeyUp(event) {
        return _this.handleCheckboxKeyPress(event);
      },
      onClick: function onClick(event) {
        return _this.handleCheckboxClick(event);
      },
      className: "checkbox " + (selected ? exports.checkedCheckboxStyle : exports.uncheckedCheckboxStyle)
    }, selected ? React.createElement(Icon_1.Icon, {
      src: checkSvg,
      width: 16,
      height: 16,
      fill: colors_1.white
    }) : null);
  };

  return Checkbox;
}(React.Component);

exports.Checkbox = Checkbox;